import React from "react"
import * as Yup from "yup"
import { Formik, Form, Field, ErrorMessage, useFormikContext, useField } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components"

import { registerLocale, setDefaultLocale } from  "react-datepicker";
import fr from 'date-fns/locale/fr';
import ElementFormOpentheso from "./ElementFormOpentheso";
import ElementFormOpenthesoAvecChamps from "./ElementFormOpenthesoAvecChamps";
import ElementFormBiblioAvecChamps from "./ElementFormBiblioAvecChamps";


registerLocale('fr', fr)
setDefaultLocale('fr');

const Champ = styled.div`
margin:10px;
padding:5px;
float:left;
display: inline-flex;
width:100%;
`
const Libelle = styled.div`
margin:10px;
padding:5px;
float:left;
`
const Label = styled.label`
padding: 5px;
height: 18px;
min-width: 180px;
`

const Help = styled.div`
margin:10px;
padding:5px;
float:left;
color: darkgray;
`

const Img = styled.img`
padding:5px;
`

const Button = styled.button`
padding:5px;
color: white;
background-color: black;
`

const DatePickerField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext()
  const [field] = useField(props)

  /*
  const padTo2Digits = (num) => {
    return num.toString().padStart(2, '0')
  }

  const formatDate = (maDate)=>  {
    return [
      padTo2Digits(maDate.getDate()),
      padTo2Digits(maDate.getMonth() + 1),
      maDate.getFullYear(),
    ].join('/');
  }
  */

  return (
    <DatePicker
      {...field}
      {...props}
      selected={(field.value && new Date(field.value)) || null}
      onChange={(val) => {
        setFieldValue(field.name, val);
      }}
    />
  )
}




const ElementForm = (params) => {

  const {typeAction, typeElement, initialValues, onSubmit} = params

  //console.log(initialValues)

  const proprietesUtiles =
  { inscription: ['titre', 'identifiant', 'collection', 'periode', 'support', 'lieu_origine'
    , 'lieu_conservation', 'type_inscription', 'biblio', 'langue', 'transcription' , 'traduction', 'commentaire'],
    donnee:['nom_fichier', 'date_donnee', 'nom_complet_stockage', 'type_donnee', 'contexte'
      , 'url_perenne'],
    document:['titre', 'inventaire', 'code_barre', 'dimensions', 'type_document'
      , 'integrite', 'conservation', 'commentaire', 'droits'],
    collection:['libelle', 'sigle', 'commentaire'],
    auteur:['nom', 'prenom', 'informations'],
    user:['nom', 'prenom', 'email', 'sesame', 'sesame_confirmation', 'role']
  }

  const initialiseFormulaire = (cles) => {
    //mettre les valeurs par défaut
    let retour = {}
    if (cles) {
      for(const cle of cles){
        //cas particulier du mot de passe
        if (cle.includes("sesame")){
          initialValues[cle] = ""
        }
        if (cle === "type_document"){
          initialValues[cle] = initialValues[cle] ? initialValues[cle] : "estampage"
        }
        if (cle.includes("integrite")){
          initialValues[cle] = initialValues[cle] ? initialValues[cle] : "partiel"
        }
        if (cle === "conservation"){
          initialValues[cle] = initialValues[cle] ? initialValues[cle] : "bon"
        }
        if (cle.includes("droits")){
          initialValues[cle] = initialValues[cle] ? initialValues[cle] : "ouvert"
        }
        if (cle.includes("langue")){
          initialValues[cle] = initialValues[cle] ? initialValues[cle] : []
        }
        if (cle.includes("contexte")){
          initialValues[cle] = initialValues[cle] ? initialValues[cle] : []
        }
        if (cle.includes("periode")){
          initialValues[cle] = initialValues[cle] ? initialValues[cle] : "non_precisee"
        }
        retour[cle] = initialValues[cle] ? initialValues[cle] : ""
      }
    }
    return retour
  }

  const FormulaireJSX = (prop) => {

    const obligatoire = () => {
      //return(<Img><img src="/img/obligatoire.png" height={15} alt="Obligatoire"/></Img> )
      return(<Img src="/img/obligatoire2.png" height="10" alt="Obligatoire"/> )
  }

    const formate_nom_fichier = (chaine) => {
      //recherche du point en partant de la fin entre 2 et le 5ième caractères
       const point = chaine.lastIndexOf(".")
      if  (point < chaine.length-2 && point > chaine.length-6){
       return chaine.substring(0,point)
      }
       return chaine
   }
    // returns all values and methods from your Formik tag
    const formikProps = useFormikContext()


    const handleChangeFichier = (event) => {
      formikProps.setFieldValue("fichier", event.target.files[0])
      console.log("valeur " + typeof document.getElementById('nom_fichier').value)
      if ( ! document.getElementById('nom_fichier').value.length) {
        formikProps.setFieldValue("nom_fichier", formate_nom_fichier(event.target.files[0].name))
      }
    }

    const handleChangeSupport = (monOption) => {
      console.log("Ma nouvelle valeur support")
      console.log(monOption)
      formikProps.setFieldValue("support", monOption.value)
    }

    const handleChangeLieuOrigine = (maValeur) => {
      console.log("Ma nouvelle valeur lieu origine")
      console.log(maValeur)
      formikProps.setFieldValue("lieu_origine", maValeur)
    }

    const handleChangeLieuConservation = (maValeur) => {
      console.log("Ma nouvelle valeur lieu conservation")
      console.log(maValeur)
      formikProps.setFieldValue("lieu_conservation", maValeur)
    }

    const handleChangeType_inscription = (monOption) => {
      console.log("Ma nouvelle valeur type d'inscription")
      console.log(monOption)
      formikProps.setFieldValue("type_inscription", monOption.value)
    }

     const handleChangeBiblio = (maValeur) => {
      console.log("Ma nouvelle référence biblio")
      console.log(maValeur)
      formikProps.setFieldValue("biblio", maValeur)
     }

    const {typeElement} = prop
    switch (typeElement){
      case 'inscription' :
          return(<Form>
          <Champ>
            <Label>Titre {obligatoire()}</Label>
            <Field name="titre" type="text" className="form-control" size="40"/>
          </Champ>
          <br/>
          <Champ>
            <Label>Identifiant  {obligatoire()}</Label>
            <Field name="identifiant" type="text" className="form-control" size="40" />
            <ErrorMessage name="identifiant" className="d-block invalid-feedback" component="span"/>
           </Champ>
          <br/>
          <ElementFormOpentheso
            nom="support"
            initialValues={initialValues['support']}
            handleChange={handleChangeSupport}
            />
          <br/>
          <ElementFormOpenthesoAvecChamps
            nom="lieu_origine"
            initialValues={initialValues['lieu_origine']}
            handleChange={handleChangeLieuOrigine}
            />
          <br/>
          <ElementFormOpenthesoAvecChamps
            nom="lieu_conservation"
            initialValues={initialValues['lieu_conservation']}
            handleChange={handleChangeLieuConservation}
            />
          <br/>
          <ElementFormOpentheso
            nom="type_inscription"
            initialValues={initialValues['type_inscription']}
            handleChange={handleChangeType_inscription}
            />
          <br/>
          <Champ>
            <Label>Période</Label>
            <Field name="periode" as="select" className="form-control">
            <option value="hellenistique">Époque hellénistique (IVe-Ier siècle avant Jésus-Christ)</option>
              <option value="romaine">Époque romaine impériale (Ier-IIIe siècle après Jésus-Christ)</option>
              <option value="antiquite">Antiquité tardive (IVe-VIIe siècle après Jésus-Christ)</option>
              <option value="islam">Débuts de l’Islam (VIIe-VIIIe siècle après Jésus-Christ)</option>
              <option value="medieval">Moyen Âge, époque moderne</option>
              <option value="non_precisee">Non précisée</option>
            </Field>
            <ErrorMessage name="type_document" className="d-block invalid-feedback" component="span"/>
            </Champ>
          <br/>
          <ElementFormBiblioAvecChamps
            nom="biblio"
            initialValues={initialValues['biblio']}
            handleChange={handleChangeBiblio}
          />
          <br/>
          <Champ>
              <Label>Langue</Label>
              <pre><Field name="langue" type="checkbox" className="form-control" value="arabe"/>arabe
              <br/><Field name="langue" type="checkbox" className="form-control" value="arameen"/>araméen
              <br/><Field name="langue" type="checkbox" className="form-control" value="arameen_edessenien"/>araméen édessénien
              <br/><Field name="langue" type="checkbox" className="form-control" value="arameen_nabateen"/>araméen nabatéen
              <br/><Field name="langue" type="checkbox" className="form-control" value="arameen_palmyrenien"/>araméen palmyrénien
              <br/><Field name="langue" type="checkbox" className="form-control" value="grec"/>grec
              <br/><Field name="langue" type="checkbox" className="form-control" value="hebreu"/>hébreu
              <br/><Field name="langue" type="checkbox" className="form-control" value="latin"/>latin
              <br/><Field name="langue" type="checkbox" className="form-control" value="phenicien"/>phénicien
              <br/><Field name="langue" type="checkbox" className="form-control" value="syriaque"/>syriaque
              <br/><Field name="langue" type="checkbox" className="form-control" value="inconnue"/>inconnue
              </pre>
            </Champ>
            <br/>
          <Champ>
            <Label>Transcription</Label>
            <Field name="transcription" as="textarea" className="form-control" rows="10"  cols="60"/>
          </Champ>
          <br/>
          <Champ>
            <Label>Traduction</Label>
            <Field name="traduction" as="textarea" className="form-control" rows="10"  cols="60"/>
          </Champ>
          <br/>
          <Champ>
            <Label>Commentaire</Label>
            <Field name="commentaire" as="textarea" className="form-control" rows="10"  cols="60"/>
          </Champ>
          <br/>
          <Champ>
          <Button type="submit" onSubmit={onSubmit}>{typeAction}</Button>
          </Champ>
        </Form>)
      case 'donnee':
        return(<Form encType="multipart/form-data">
          <Libelle>Merci de transférer un fichier, ou de saisir une URL pérenne de cette donnée</Libelle>
          <Champ>
            <Label>Fichier</Label>
            <Field name="fichier_transfert"
              type="file"
              className="form-control"
              onChange={handleChangeFichier}
              />
             <ErrorMessage name="fichier" className="d-block invalid-feedback" component="span"/>
             <Field name="fichier"
              type="hidden"
              value=""
              />
          </Champ>
          <Help>A partir de ce fichier le nom pourra être déduit ainsi que la date une fois le fichier transféré,
              vous pouvez également saisir directement ces 2 valeurs.
          </Help>
          <Champ>
            <Label>URL perenne</Label>
            <Field name="url_perenne" type="text" className="form-control" size="40" />
            <ErrorMessage name="url_perenne" className="d-block invalid-feedback" component="span"/>
          </Champ>
          <br/>
          <Champ>
              <Label>Contexte</Label>
              <pre><Field name="contexte" type="checkbox" className="form-control" value="ambiance"/>Ambiance
              <br/><Field name="contexte" type="checkbox" className="form-control" value="archeologie"/>Archéologie
              <br/><Field name="contexte" type="checkbox" className="form-control" value="conservation"/>Conservation
              <br/><Field name="contexte" type="checkbox" className="form-control" value="epigraphiste_au_travail"/>Épigraphiste au travail
              <br/><Field name="contexte" type="checkbox" className="form-control" value="folklore"/>Folklore
              <br/><Field name="contexte" type="checkbox" className="form-control" value="paysage"/>Paysage
              <br/><Field name="contexte" type="checkbox" className="form-control" value="portrait"/>Portrait
              </pre>
          </Champ>
          <br/>
          <Champ>
              <Label>Nom du fichier</Label>
              <Field id="nom_fichier" name="nom_fichier" type="text" className="form-control" size="40" />
          </Champ>
          <br/>
          <Champ>
              <Label>Date du fichier</Label>
              <DatePickerField name="date_donnee" dateFormat="dd/MM/yyyy"/>
         </Champ>
         <br/>
          <Champ>
          <Button type="submit" onSubmit={onSubmit}>{typeAction}</Button>
          </Champ>
        </Form>)
      case 'user':
        return(<Form>
          <Champ>
            <Label>Prénom</Label>
            <Field name="prenom" type="text" className="form-control" size="40" />
          </Champ>
          <br/>
          <Champ>
            <Label>Nom {obligatoire()}</Label>
            <Field name="nom" type="text" className="form-control" size="40" />
            <ErrorMessage name="nom" className="d-block invalid-feedback" component="span"/>
          </Champ>
          <br/>
          <Champ><Label>Email {obligatoire()}</Label>
          <Field name="email" type="text" autoComplete="username" className="form-control" size="40" />
          <ErrorMessage name="email" className="d-block invalid-feedback" component="span"/>
          </Champ>
          <br/>
          <Champ><Label>Role</Label>
          <pre>
          <Field name="role" type="radio" className="form-control" value="membre"/>Membre
          <br/><Field name="role" type="radio" className="form-control" value="admin"/>Admin
          </pre>
          </Champ>
          <br/>
          <Champ><Label>Mot de passe {obligatoire()}</Label>
          <Field name="sesame" type="password" className="form-control" size="40"/>
          <ErrorMessage name="sesame" className="d-block invalid-feedback" component="span"/>
          </Champ>
          <Champ><Label>Mot de passe (confirmation) {obligatoire()}</Label>
          <Field name="sesame_confirmation" type="password"  className="form-control" size="40" />
          <ErrorMessage name="sesame_confirmation" className="d-block invalid-feedback" component="span"/>
          </Champ>
          <br/>
          <Button type="submit" onSubmit={onSubmit}>{typeAction}</Button>
        </Form>)
      case 'auteur':
          return(<Form>
            <Champ>
              <Label>Prénom ou Initiales{obligatoire()}</Label>
              <Field name="prenom" type="text" className="form-control" size="40" />
            </Champ>
            <br/>
            <Champ>
              <Label>Nom {obligatoire()}</Label>
              <Field name="nom" type="text" className="form-control" size="40" />
              </Champ>
            <br/>
              <Champ>
                <Label>Informations</Label>
                <Field name="informations" as="textarea" className="form-control" rows="10"  cols="60"/>
              </Champ>
            <br/>
            <Button type="submit" onSubmit={onSubmit}>{typeAction}</Button>
        </Form>)
      case 'document':
          return(<Form>
            <Champ>
              <Label>Titre {obligatoire()}</Label>
              <Field name="titre" type="text" className="form-control" size="40" />
              <ErrorMessage name="titre" className="d-block invalid-feedback" component="span"/>
            </Champ>
            <br/>
            <Champ>
              <Label>Code Barre</Label>
              <Field name="code_barre" type="text" className="form-control" size="40" />
              </Champ>
            <br/>
            <Champ>
              <Label>Numéro d'inventaire</Label>
              <Field name="inventaire" type="text" className="form-control" size="40" />
              </Champ>
            <br/>
            <Champ>
              <Label>Type de document</Label>
              <Field name="type_document" as="select" className="form-control">
                <option value="estampage">Estampage</option>
                <option value="calque">Calque</option>
                <option value="dessin">Dessin</option>
                <option value="diapositive">Diapositive</option>
                <option value="fiche">Fiche</option>
                <option value="negatif">Négatif</option>
                <option value="plaque_verre">Plaque de verre</option>
                <option value="carnet">Carnet</option>
                <option value="photo">Tirage photo</option>
              </Field>
             <ErrorMessage name="type_document" className="d-block invalid-feedback" component="span"/>
              </Champ>
            <br/>
            <Champ>
              <Label>Dimension</Label>
              <Field name="dimensions" type="text" className="form-control" size="40" />
              <ErrorMessage name="dimensions" className="d-block invalid-feedback" component="span"/>
            </Champ>
            <br/>
            <Champ>
              <Label>Intégrité</Label>
              <Field name="integrite" as="select" className="form-control">
                <option value="partiel">Partiel</option>
                <option value="total">Total</option>
              </Field>
            </Champ>
            <br/>
            <Champ>
              <Label>Etat de conservation</Label>
              <Field name="conservation" as="select" className="form-control">
              <option value="bon">Bon</option>
              <option value="mauvais">Mauvais</option>
              </Field>
            </Champ>
            <br/>
            <Champ>
              <Label>Droits</Label>
              <Field name="droits" as="select" className="form-control">
              <option value="ouvert">Ouvert</option>
              <option value="restreint">Restreint</option>
              <option value="ferme">Fermé</option>
              </Field>
            </Champ>
            <br/>
            <Champ>
                <Label>Commentaire</Label>
                <Field name="commentaire" as="textarea" className="form-control" rows="10"  cols="60"/>
              </Champ>
            <br/>
            <button type="submit" onSubmit={onSubmit}>{typeAction}</button>
        </Form>)
      case 'collection':
        return(<Form>
          <Champ>
            <Label>Libelle {obligatoire()}</Label>
            <Field name="libelle" type="text" className="form-control" size="40" />
            <ErrorMessage name="libelle" className="d-block invalid-feedback" component="span"/>
          </Champ>
          <br/>
          <Champ>
            <Label>Sigle</Label>
            <Field name="sigle" type="text" className="form-control" size="40" />
            <ErrorMessage name="sigle" className="d-block invalid-feedback" component="span"/>
            </Champ>
          <br/>
          <Champ>
              <Label>Commentaire</Label>
              <Field name="commentaire" as="textarea" className="form-control" rows="10"  cols="60"/>
            </Champ>
          <br/>
          <Button type="submit" onSubmit={onSubmit}>{typeAction}</Button>
        </Form>)
      default:
        return(<Form>Type non traité (prise en charge par Zotero uniquement ?)</Form>)
    }
  }
  const SUPPORTED_FORMATS = ["image/jpg", "image/png", "image/jpeg", "image/gif", "image/svg+xml", "application/pdf", "application/xml"]

  const testTaille = (fichier) => {
    console.log("taille fichier " + fichier.size)
    const TAILLE_MAX = 50*1024*1024
    const retour = (fichier.size<TAILLE_MAX) ? true : false
    return  retour
  }

  const validationSchemaParType = (typeElement) => {
    switch (typeElement) {
      case 'inscription' :
        return ({
          identifiant: Yup.string().required("Obligatoire"),
         })
      case 'lieu' :
      return ({
        nom_etablissement: Yup.string().required("Obligatoire"),
        })
      case 'document' :
        return({
          titre: Yup.string().required("Obligatoire"),
          code_barre: Yup.string().required("Obligatoire")
      })
      case 'auteur' :
        return ({
          nom: Yup.string().required("Obligatoire"),
        })
      case 'donnee' :
        return ({
          nom_fichier: Yup.string().required("Obligatoire"),
          fichier: Yup.mixed()
            .test(
              "size",
              "Taille de fichier trop importante",
              value => (value) ? testTaille(value) : true
            )
            .test(
              "type",
              "Type de fichier invalide",
              value => (value) ? SUPPORTED_FORMATS.includes(value?.type) : true
            )
        })
      case 'user' :
      return ({
        nom: Yup.string().required("Obligatoire"),
        email: Yup.string().email('Email incorrect').required('Obligatoire'),
        sesame: Yup.string().required('Obligatoire'),
        sesame_confirmation: Yup.string()
          .oneOf([Yup.ref('sesame'), null], 'Les mots de passe doivent correspondre'),
        })
      default :
      //pas de vérification de champ
      return ({})
    }
  }

  const validationSchema = Yup.object().shape(validationSchemaParType(typeElement))

  const FormWrapper = () => {
        return (<Formik
          initialValues={initialiseFormulaire(proprietesUtiles[typeElement])}
          validationSchema={validationSchema}
          onSubmit={onSubmit}>
          <FormulaireJSX typeElement={typeElement}/>
        </Formik>)
  }

  return(
    <>
      {FormWrapper()}
    </>
  )
}
export default ElementForm